module.exports = __webpack_public_path__ + "img/20190705163615572.079fa0b4.png";